import { Input } from '@skytech/ui'
import type { FieldProps } from 'formik'
import { Field } from 'formik'

import { Translation } from '@/app/translations/Translation'

export const SduHuldtOgLillevik = () => (
  <>
    <div className="mt-3">
      <Field name="salaryDeductionCodeDevice">
        {({ field, meta }: FieldProps) => (
          <Input
            isFullWidth
            capitalizeLabel
            id="salaryDeductionCodeDevice"
            label={
              <>
                <Translation id="Accounting code mobile usage" />*
              </>
            }
            marginBottom={16}
            touched={meta.touched}
            error={meta.error}
            {...field}
          />
        )}
      </Field>
    </div>
    <div className="mt-3">
      <Field name="projectUsage">
        {({ field, meta }: FieldProps) => (
          <Input
            isFullWidth
            capitalizeLabel
            id="projectUsage"
            label={
              <>
                <Translation id="Project mobile usage" />*
              </>
            }
            marginBottom={16}
            touched={meta.touched}
            error={meta.error}
            {...field}
          />
        )}
      </Field>
    </div>
    <div className="mt-3">
      <Field name="departmentOverrideDevice">
        {({ field, meta }: FieldProps) => (
          <Input
            isFullWidth
            capitalizeLabel
            id="departmentOverrideDevice"
            label={
              <>
                <Translation id="Department override mobile use	" />*
              </>
            }
            marginBottom={16}
            touched={meta.touched}
            error={meta.error}
            {...field}
          />
        )}
      </Field>
    </div>
  </>
)
